import {connect} from "react-redux";
import style from "./Main.module.scss";
import Map from "../../components/map/map";
import Menu from "../../components/menu/menu";
import Bage from "../../components/badges/badges";
import {getAllDevicesByMap, getGdacs} from "../../thunk/device";
import {openSocketConnection} from "../../thunk/sockets";
import React, {useEffect, useState} from "react";
import {getAlerts} from "../../thunk/alerts";
import Alerts from "../../components/alerts/alerts";
import Header from "../../components/header/header";
import {getCookie} from "../../util/cookie";
import {checkToken} from "../../thunk/login";
import Tabs from "../../components/tabs/tabs";
import MenuGdacs from "../../components/menuGdacs/menuGdacs";
import ListGdacs from "../../components/listGdacs/listGdacs";
import FilterGdacs from "../../components/filterGdacs/filterGdacs";

function Main({
                  getAlerts,
                  openSocketConnection,
                  getAllDevicesByMap,
                  checkToken,
                  activeTab,
                  getGdacs,
                  loadData
              }) {

    useEffect(() => {
        const cookieToken = getCookie("token");
        if (cookieToken) {
            checkToken();
        }
        // if (activeTab === "gdacs") {
        //     getGdacs();
        // }
        // if (activeTab === "aqi") {
        //     getAllDevicesByMap();
        //     getAlerts();
        // }
        openSocketConnection("base");

    }, [])

    useEffect(() => {
        if (activeTab === "gdacs") {
            getGdacs({type: ["EQ"], alertLevel: ["red", "orange"]});
        }
        if (activeTab === "aqi") {
            getAllDevicesByMap();
            getAlerts();
        }
    }, [activeTab])
    const [map, setMap] = useState(null)

    return (
        <>
            <div className={style.container}>
                    {loadData && activeTab === "aqi" && <Alerts/>}
                    {loadData && activeTab === "gdacs" && <ListGdacs/>}
                    {/* {loadData && activeTab === "gdacs" && <FilterGdacs/>} */}
                    <Header
                        map={map}
                    />
                    {activeTab === "aqi" && <Menu map={map}/>}
                    {activeTab === "gdacs" && <MenuGdacs map={map}/>}
                    <Tabs styleClass={style.bages}/>
                    {/* <Bage styleClass={style.bages}/> */}
                    <Map
                        map={map}
                        setMap={setMap}
                    />
            </div>
        </>
    );
}

const mapStateToProps = state => ({
    alerts: state.alerts,
    badges: state.page.badges,
    activeTab: state.page.activeTab,
    loadData: state.page.loadData
});

const mapDispatchToProps = dispatch => ({
    getAlerts: data => dispatch(getAlerts(data)),
    getGdacs: data => dispatch(getGdacs(data)),
    openSocketConnection: data => dispatch(openSocketConnection(data)),
    getAllDevicesByMap: data => dispatch(getAllDevicesByMap(data)),
    checkToken: data => dispatch(checkToken(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);